import { assign } from "lodash";

import { BaseDto } from "./base.dto";

import { DateOfBirthDto } from "./date-of-birth.dto";
import { PagingDto } from "./paging.dto";
import { UserDto } from "./user.dto";
import { MallOrderDto } from "./mall-order.dto";

// Implements: FEAT-001#AC-011, AC-011
export const MALL_COUPON_SOURCE = {
  STANDARD: "standard",
  STAMP_COLLECTION: "stamp_collection",
} as const;

export type MallCouponSource = typeof MALL_COUPON_SOURCE[keyof typeof MALL_COUPON_SOURCE];

export class MallCouponCodeDto {
  id: string;
  couponCode: string;
  limitUsage: number;
  usedCount: number;
  isValid: boolean;
}

export class CreateMallCouponDto {
  ownerIds?: string;
  khmerTitle: string;
  englishTitle: string;
  amount: number;
  minOrder: number;
  maxOrder: number;
  discountType: string;
  productType?: string;
  givenType: string;
  limitUsage?: number;
  startDate: DateOfBirthDto;
  endDate: DateOfBirthDto;
  tenantId?: string;
  type: string;
  codeType: string;
  couponCode?: string;
  numberOfCode: number;
  prefix?: string;
  minTenant: number;
  maxTenant: number;

  static create() {
    return assign(new CreateMallCouponDto(), {
      productType: "physical",
    });
  }
}

export class FindMallCouponDto extends PagingDto {
  status?: string;
  searchText?: string;
  mallId?: string;
  productType?: string;
  source?: MallCouponSource;
}

export class ExportHistoryDto {
  startDate?: Date;
  endDate?: Date;
  source?: MallCouponSource;
}

export class MallCouponDto extends BaseDto {
  khmerTitle: string;
  englishTitle: string;
  amount: number;
  limitUsage: number;
  discountType: string;
  givenType: string;
  codeType: string;
  enabled: boolean;
  creator: UserDto;
  couponCodes: MallCouponCodeDto[];
  minOrder: number;
  maxOrder: number;
  startDate: DateOfBirthDto;
  endDate: DateOfBirthDto;
  ownerIds: string[];
  tenantId: string;
  type: string;
  numberOfCode: number;
  prefix: string;
  minTenant: number;
  maxTenant: number;
  productType?: string;
  source?: MallCouponSource;

  static create() {
    return assign(new MallCouponDto(), {
      maxOrder: 1999.99,
      productType: "physical",
    });
  }
}

export class MallCouponHistoryDto extends BaseDto {
  owner: UserDto;
  total: number;
  couponTotal: number;
  couponCode: string;
  discountAmount: number;
  discountType: string;
  mallOrder: MallOrderDto;
  mallCoupon: MallCouponDto;

  static create() {
    return new MallCouponHistoryDto();
  }
}
